import { Link } from 'react-router-dom';
import LogoCizim from '../components/brand/LogoCizim';
import { logoUst } from '../components/brand/markaYollari';
import Footer from './home/components/Footer';

interface LegalLayoutProps {
  title: string;
  children: React.ReactNode;
}

export default function LegalLayout({ title, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex-shrink-0">
              <LogoCizim src="/images/logo.webp" alt="Mahallebi" yol={logoUst} renk="#8C1427" className="h-10" />
            </Link>
            <Link
              to="/"
              className="text-sm text-gray-500 hover:text-[#e77e23] transition-colors"
            >
              ← Ana Sayfa
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-[#111827] mb-8">{title}</h1>
          <div className="prose prose-gray max-w-none text-[#374151] leading-relaxed">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
